import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-neutral-dark selection:bg-primary selection:text-white" data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Navbar data-id="element-3" />
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          <Route path="/services" element={<ServicesPage data-id="element-10" />} data-id="element-9" />
          <Route path="/how-it-works" element={<HowItWorksPage data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
        </Routes>
        <Footer data-id="element-15" />
      </BrowserRouter>
    </div>;
}